export const STAT_KEYS = [
  'hull',
  'regen',
  'damage',
  'fireRange',
  'moveSpeed',
  'passiveScrap',
] as const;

export type StatKey = (typeof STAT_KEYS)[number];

export const STAT_LABELS: Readonly<Record<StatKey, string>> = {
  hull: 'Hull',
  regen: 'Regen',
  damage: 'Damage',
  fireRange: 'Fire range',
  moveSpeed: 'Move speed',
  passiveScrap: 'Passive scrap',
};

export const STAT_COLORS: Readonly<Record<StatKey, string>> = {
  hull: '#43d155',
  regen: '#1f8f5e',
  damage: '#ff7263',
  fireRange: '#ffbb42',
  moveSpeed: '#8098ff',
  passiveScrap: '#f5e050',
};

export const STAT_MIN = 0;
export const STAT_MAX = 30;
export const STAT_DEFAULT = 11;
export const STAT_TOTAL = 66;
